import axios from 'axios';

export function getUserAndDepartmentDetailsFromAccountability(accountabilityId) {
  return axios.get('VragensetVerantwoording/GetUserAndDepartmentDetailsFromAccountability?accountabilityId=' + accountabilityId)
    .then(response => response.data);
}
